import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Protocol } from '@uniswap/router-sdk';
import { TradeType } from '@uniswap/sdk-core';
import _ from 'lodash';
import { CurrencyAmount } from '../../../util/amounts';
import { routeToString } from '../../../util/routes';
/**
 * Represents a quote for swapping on a V2 only route. Contains all information
 * such as the route used, the amount specified by the user, the type of quote
 * (exact in or exact out), the quote itself, and gas estimates.
 *
 * @export
 * @class V2RouteWithValidQuote
 */

export var V2RouteWithValidQuote = /*#__PURE__*/function () {
  function V2RouteWithValidQuote(_ref) {
    var amount = _ref.amount,
        rawQuote = _ref.rawQuote,
        percent = _ref.percent,
        route = _ref.route,
        gasModel = _ref.gasModel,
        quoteToken = _ref.quoteToken,
        tradeType = _ref.tradeType,
        v2PoolProvider = _ref.v2PoolProvider;

    _classCallCheck(this, V2RouteWithValidQuote);

    this.protocol = Protocol.V2;
    this.amount = amount;
    this.rawQuote = rawQuote;
    this.quote = CurrencyAmount.fromRawAmount(quoteToken, rawQuote.toString());
    this.percent = percent;
    this.route = route;
    this.gasModel = gasModel;
    this.quoteToken = quoteToken;
    this.tradeType = tradeType;

    var _this$gasModel$estima = this.gasModel.estimateGasCost(this),
        gasEstimate = _this$gasModel$estima.gasEstimate,
        gasCostInToken = _this$gasModel$estima.gasCostInToken,
        gasCostInUSD = _this$gasModel$estima.gasCostInUSD;

    this.gasCostInToken = gasCostInToken;
    this.gasCostInUSD = gasCostInUSD;
    this.gasEstimate = gasEstimate; // If its exact out, we need to request *more* of the input token to account for the gas.

    if (this.tradeType == TradeType.EXACT_INPUT) {
      var quoteGasAdjusted = this.quote.subtract(gasCostInToken);
      this.quoteAdjustedForGas = quoteGasAdjusted;
    } else {
      var _quoteGasAdjusted = this.quote.add(gasCostInToken);

      this.quoteAdjustedForGas = _quoteGasAdjusted;
    }

    this.poolAddresses = _.map(route.pairs, function (p) {
      return v2PoolProvider.getPoolAddress(p.token0, p.token1).poolAddress;
    });
    this.tokenPath = this.route.path;
  }

  _createClass(V2RouteWithValidQuote, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.percent.toFixed(2), "% QuoteGasAdj[").concat(this.quoteAdjustedForGas.toExact(), "] Quote[").concat(this.quote.toExact(), "] Gas[").concat(this.gasEstimate.toString(), "] = ").concat(routeToString(this.route));
    }
  }]);

  return V2RouteWithValidQuote;
}();
/**
 * Represents a quote for swapping on a V3 only route. Contains all information
 * such as the route used, the amount specified by the user, the type of quote
 * (exact in or exact out), the quote itself, and gas estimates.
 *
 * @export
 * @class V3RouteWithValidQuote
 */

export var V3RouteWithValidQuote = /*#__PURE__*/function () {
  function V3RouteWithValidQuote(_ref2) {
    var amount = _ref2.amount,
        rawQuote = _ref2.rawQuote,
        sqrtPriceX96AfterList = _ref2.sqrtPriceX96AfterList,
        initializedTicksCrossedList = _ref2.initializedTicksCrossedList,
        quoterGasEstimate = _ref2.quoterGasEstimate,
        percent = _ref2.percent,
        route = _ref2.route,
        gasModel = _ref2.gasModel,
        quoteToken = _ref2.quoteToken,
        tradeType = _ref2.tradeType,
        v3PoolProvider = _ref2.v3PoolProvider;

    _classCallCheck(this, V3RouteWithValidQuote);

    this.protocol = Protocol.V3;
    this.amount = amount;
    this.rawQuote = rawQuote;
    this.sqrtPriceX96AfterList = sqrtPriceX96AfterList;
    this.initializedTicksCrossedList = initializedTicksCrossedList;
    this.quoterGasEstimate = quoterGasEstimate;
    this.quote = CurrencyAmount.fromRawAmount(quoteToken, rawQuote.toString());
    this.percent = percent;
    this.route = route;
    this.gasModel = gasModel;
    this.quoteToken = quoteToken;
    this.tradeType = tradeType;

    var _this$gasModel$estima2 = this.gasModel.estimateGasCost(this),
        gasEstimate = _this$gasModel$estima2.gasEstimate,
        gasCostInToken = _this$gasModel$estima2.gasCostInToken,
        gasCostInUSD = _this$gasModel$estima2.gasCostInUSD;

    this.gasCostInToken = gasCostInToken;
    this.gasCostInUSD = gasCostInUSD;
    this.gasEstimate = gasEstimate; // If its exact out, we need to request *more* of the input token to account for the gas.

    if (this.tradeType == TradeType.EXACT_INPUT) {
      var quoteGasAdjusted = this.quote.subtract(gasCostInToken);
      this.quoteAdjustedForGas = quoteGasAdjusted;
    } else {
      var _quoteGasAdjusted2 = this.quote.add(gasCostInToken);

      this.quoteAdjustedForGas = _quoteGasAdjusted2;
    }

    this.poolAddresses = _.map(route.pools, function (p) {
      return v3PoolProvider.getPoolAddress(p.token0, p.token1, p.fee).poolAddress;
    });
    this.tokenPath = this.route.tokenPath;
  }

  _createClass(V3RouteWithValidQuote, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.percent.toFixed(2), "% QuoteGasAdj[").concat(this.quoteAdjustedForGas.toExact(), "] Quote[").concat(this.quote.toExact(), "] Gas[").concat(this.gasEstimate.toString(), "] = ").concat(routeToString(this.route));
    }
  }]);

  return V3RouteWithValidQuote;
}();